import React from 'react';

const ListVersionsTable = ({tableData}) => {
  return (
    <div className='table_container iransans'>
      <table>
        <thead>
        <tr>
          <th>ردیف</th>
          <th>کد ورژن</th>
          <th>نسخه ورژن</th>
          <th>از تاریخ</th>
          <th>تا تاریخ</th>
          <th>مدت زمان انجام <span>(نفر ساعت)</span></th>
          <th>وظیفه</th>
        </tr>
        </thead>
        <tbody>
        {tableData
          ? tableData.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.version}</td>
              <td>لورم ایپسوم</td>
              <td>{item.startDate}</td>
              <td>{item.endDate}</td>
              <td>{item.duration}</td>
              <td>{item.task}</td>
            </tr>
          ))
          : null}
        </tbody>
      </table>
    </div>
  );
};

export default ListVersionsTable;